import { Injectable, OnDestroy } from '@angular/core';
import { CustomGridHeaderComponent } from '../ag-grid-components/custom-grid-header/custom-grid-header.component';
import { SalesTrendsGridConfigService } from './sales-trends-grid-config.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SalesTrendOrderGridConfigService implements OnDestroy{
  month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  date = new Date();
  sortModel:any[]=[];
  currentYear: number = new Date().getFullYear();
  private destroy$ = new Subject<void>();

  constructor(private salesTrendsGridConfigService : SalesTrendsGridConfigService) { }

  selected="weekly";
  orderCommonColumnDefs:any = [
    {
      field: "Active",
      headerTooltip: "Active",
      backendFields: ["Active"],
      filter: "booleanFilterComponent",
      hide: true,
      required:true,
      valueFormatter: (param) => (param.value ? "Yes" : "No"),
      width: 95,
    },
    {
      headerName: "Product Information",
      field: "Sku",
      backendFields: ["Sku","Asin","ImageUrl","Title"],
      width: 400,
      minWidth: 400,
      headerClass: "border-right",
      cellClass: "border-right", 
      cellRenderer: "skuCellRendererComponent",
      rowGroup:true,
      required:true,
      hide:true,
      filter: "agMultiColumnFilter",
      sortable:false,
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
            display: "accordion",
            title: "SKU",
            filterParams: {
              defaultOption: "contains",
              maxNumConditions : 1,
            },
          },
          {
            filter: "agTextColumnFilter",
            display: "accordion",
            title: "ASIN",
            filterParams: {
              defaultOption: "contains",
              maxNumConditions : 1,
            },
          },
          {
            display: "accordion",
            title: "Description",
            filter: "agTextColumnFilter",
            filterParams: {
              defaultOption: "contains",
              maxNumConditions : 1,
            },
          },
        ],
      },
    },
    {
      headerName: "Marketplace",
      backendFields: ["Channel","Account","Sales"],
      field: "Account",
      filter: "agTextColumnFilter",
      width: 110,
      minWidth: 100,
    },
    {
      headerName: "Value",
      field:'Value',
      width: 195,
      minWidth: 195,
      valueFormatter: (param) => {
        if(param.value == 'Sales'){
          return param.value =  'Revenue'
        }
      },
      cellStyle:{ "border-left": "2px solid #D6D6D6" },
      sortable: false,
    },
  ] 

  salesColumnDefs:any = [
    {
      headerName: "This week",
      field: "Col1",
      width: 180,
      minWidth: 180,
      filter: "agNumberColumnFilter",
      backendFields: ["G1Sales","G1SalesDiff","G1QtySold","G1QtySoldDiff","G1Returns","G1ReturnsDiff","G1Profit","G1ProfitDiff"],
      headerClass: "orange",
      cellStyle:{ "border-left": "2px solid #D6D6D6" },
      cellRenderer : "salesTrendsCellRendere",
      isSumColumns:true,
      sortable: true,
      headerComponent: CustomGridHeaderComponent,
      headerComponentParams :{
        isSalesTrend:true,
        callback: this.onHeaderCallback.bind(this)
      },
      cellRendererParams:(params) =>{
        return { col:1, isOrder:true,defaultColumns:this.salesTrendsGridConfigService.defaultColumns }
      },
    },
    {
      headerName: "Last week",
      field: "Col2",
      backendFields:["G2Sales","G2SalesDiff","G2QtySold","G2QtySoldDiff","G2Returns","G2ReturnsDiff","G2Profit","G2ProfitDiff"],
      width: 180,
      minWidth: 180,
      headerClass: "primary-light",
      filter: "agNumberColumnFilter",
      cellStyle:{ "border-left": "2px solid #D6D6D6" },
      isSumColumns:true,
      cellRenderer : "salesTrendsCellRendere",
      sortable: true,
      cellRendererParams:(params) =>{
        return { col:2, isOrder:true,defaultColumns:this.salesTrendsGridConfigService.defaultColumns }
      },
      headerComponent: CustomGridHeaderComponent,
      headerComponentParams :{
        isSalesTrend:true,
        callback: this.onHeaderCallback.bind(this)
      },
    },
    {    
      headerName: "2 weeks ago",
      backendFields:["G3Sales","G3SalesDiff","G3QtySold","G3QtySoldDiff","G3Returns","G3ReturnsDiff","G3Profit","G3ProfitDiff"],
      field: "Col3",
      width: 180,
      minWidth: 180,
      filter: "agNumberColumnFilter",
      headerClass: "purple",
      cellStyle:{ "border-left": "2px solid #D6D6D6" },
      isSumColumns:true,
      cellRenderer : "salesTrendsCellRendere",
      sortable: true,
      cellRendererParams:(params) =>{
        return { col: 3, isOrder:true,defaultColumns:this.salesTrendsGridConfigService.defaultColumns}
      },
      headerComponent: CustomGridHeaderComponent,
      headerComponentParams :{
        isSalesTrend:true,
        callback: this.onHeaderCallback.bind(this)
      },
    },
    {
      headerName: "3 weeks ago",
      field: "Col4",
      backendFields:["G4Sales","G4SalesDiff","G4QtySold","G4QtySoldDiff","G4Returns","G4ReturnsDiff","G4Profit","G4ProfitDiff"],
      width: 180,
      minWidth: 180,
      filter: "agNumberColumnFilter",
      headerClass: "success-light",
      cellStyle:{ "border-left": "2px solid #D6D6D6" },
      cellRenderer : "salesTrendsCellRendere",
      isSumColumns:true,
      sortable: true,
      cellRendererParams:(params) =>{
        return { col:4 ,isOrder:true,defaultColumns:this.salesTrendsGridConfigService.defaultColumns}
      },
      headerComponent: CustomGridHeaderComponent,
      headerComponentParams :{
        isSalesTrend:true,
        callback: this.onHeaderCallback.bind(this)
      },
    },
    {
      headerName: "4 weeks ago",
      field: "Col5",
      backendFields:["G5Sales","G5SalesDiff","G5QtySold","G5QtySoldDiff","G5Returns","G5ReturnsDiff","G5Profit","G5ProfitDiff"],
      width: 180,
      minWidth: 180,
      filter: "agNumberColumnFilter",
      headerClass: "spray",
      cellStyle:{ "border-left": "2px solid #D6D6D6" },
      isSumColumns:true,
      cellRenderer : "salesTrendsCellRendere",
      sortable: true,
      cellRendererParams:(params) =>{
        return { col:5, isOrder:true,defaultColumns:this.salesTrendsGridConfigService.defaultColumns}
      },
      headerComponent: CustomGridHeaderComponent,
      headerComponentParams :{
        isSalesTrend:true,
        callback: this.onHeaderCallback.bind(this)
      },
    },
  ]

  orderMonthlyColumns:any = [
    {
      headerName: "",
      field: "Col1",
      width: 180,
      minWidth: 180,
      filter: "agNumberColumnFilter",
      backendFields: ["G1Sales","G1SalesDiff","G1QtySold","G1QtySoldDiff","G1Returns","G1ReturnsDiff","G1Profit","G1ProfitDiff"],
      headerClass: "orange",
      cellStyle:{ "border-left": "2px solid #D6D6D6" },
      cellRenderer : "salesTrendsCellRendere",
      isSumColumns:true,
      sortable: true,
      cellRendererParams:(params) =>{
        return { col:1, isOrder:true,defaultColumns:this.salesTrendsGridConfigService.defaultColumns }
      },
      headerComponent: CustomGridHeaderComponent,
      headerComponentParams :{
        isSalesTrend:true,
        callback: this.onHeaderCallback.bind(this)
      },
    },
    {
      headerName: "",
      field: "Col2",
      backendFields:["G2Sales","G2SalesDiff","G2QtySold","G2QtySoldDiff","G2Returns","G2ReturnsDiff","G2Profit","G2ProfitDiff"],
      width: 180,
      minWidth: 180,
      filter: "agNumberColumnFilter",
      headerClass: "primary-light",
      cellStyle:{ "border-left": "2px solid #D6D6D6" },
      isSumColumns:true,
      cellRenderer : "salesTrendsCellRendere",
      sortable: true,
      cellRendererParams:(params) =>{
        return { col:2, isOrder:true,defaultColumns:this.salesTrendsGridConfigService.defaultColumns }
      },
      headerComponent: CustomGridHeaderComponent,
      headerComponentParams :{
        isSalesTrend:true,
        callback: this.onHeaderCallback.bind(this)
      },
    },
    {    
      headerName: "",
      field: "Col3",
      backendFields:["G3Sales","G3SalesDiff","G3QtySold","G3QtySoldDiff","G3Returns","G3ReturnsDiff","G3Profit","G3ProfitDiff"],
      width: 180,
      minWidth: 180,
      headerClass: "purple",
      filter: "agNumberColumnFilter",
      cellStyle:{ "border-left": "2px solid #D6D6D6" },
      isSumColumns:true,
      cellRenderer : "salesTrendsCellRendere",
      sortable: true,
      cellRendererParams:(params) =>{
        return { col: 3, isOrder:true,defaultColumns:this.salesTrendsGridConfigService.defaultColumns}
      },
      headerComponent: CustomGridHeaderComponent,
      headerComponentParams :{
        isSalesTrend:true,
        callback: this.onHeaderCallback.bind(this)
      },
    },
    {
      headerName: "",
      field: "Col4",
      backendFields:["G4Sales","G4SalesDiff","G4QtySold","G4QtySoldDiff","G4Returns","G4ReturnsDiff","G4Profit","G4ProfitDiff"],
      width: 180,
      minWidth: 180,
      headerClass: "success-light",
      filter: "agNumberColumnFilter",
      cellStyle:{ "border-left": "2px solid #D6D6D6" },
      isSumColumns:true,
      cellRenderer : "salesTrendsCellRendere",
      sortable: true,
      cellRendererParams:(params) =>{
        return { col:4, isOrder:true,defaultColumns:this.salesTrendsGridConfigService.defaultColumns }
      },
      headerComponent: CustomGridHeaderComponent,
      headerComponentParams :{
        isSalesTrend:true,
        callback: this.onHeaderCallback.bind(this)
      },
    },
    {
      headerName: "",
      field: "Col5",
      backendFields:["G5Sales","G5SalesDiff","G5QtySold","G5QtySoldDiff","G5Returns","G5ReturnsDiff","G5Profit","G5ProfitDiff"],
      width: 180,
      minWidth: 180,
      headerClass: "spray",
      filter: "agNumberColumnFilter",
      cellStyle:{ "border-left": "2px solid #D6D6D6" },
      isSumColumns:true,
      cellRenderer : "salesTrendsCellRendere",
      sortable: true,
      cellRendererParams:(params) =>{
        return { col:5, isOrder:true,defaultColumns:this.salesTrendsGridConfigService.defaultColumns}
      },
      headerComponent: CustomGridHeaderComponent,
      headerComponentParams :{
        isSalesTrend:true,
        callback: this.onHeaderCallback.bind(this)
      },
    },
  ]

  orderQuaterlyColumn:any = [
    {
      headerName: "",
      backendFields: ["G1Sales","G1SalesDiff","G1QtySold","G1QtySoldDiff","G1Returns","G1ReturnsDiff","G1Profit","G1ProfitDiff"],
      field: "Col1",
      width: 180,
      minWidth: 180,
      headerClass: "orange",
      filter: "agNumberColumnFilter",
      cellStyle:{ "border-left": "2px solid #D6D6D6" },
      cellRenderer : "salesTrendsCellRendere",
      isSumColumns:true,
      sortable: true,
      cellRendererParams:(params) =>{
        return { col:1, isOrder:true,defaultColumns:this.salesTrendsGridConfigService.defaultColumns }
      },
      headerComponent: CustomGridHeaderComponent,
      headerComponentParams :{
        isSalesTrend:true,
        callback: this.onHeaderCallback.bind(this)
      },
    },
    {
      headerName: "",
      field: "Col2",
      backendFields:["G2Sales","G2SalesDiff","G2QtySold","G2QtySoldDiff","G2Returns","G2ReturnsDiff","G2Profit","G2ProfitDiff"],
      width: 180,
      minWidth: 180,
      headerClass: "primary-light",
      cellStyle:{ "border-left": "2px solid #D6D6D6" },
      filter: "agNumberColumnFilter",
      cellRenderer : "salesTrendsCellRendere",
      isSumColumns:true,
      sortable: true,
      cellRendererParams:(params) =>{
        return { col:2, isOrder:true,defaultColumns:this.salesTrendsGridConfigService.defaultColumns }
      },
      headerComponent: CustomGridHeaderComponent,
      headerComponentParams :{
        isSalesTrend:true,
        callback: this.onHeaderCallback.bind(this)
      },
    },
    {    
      headerName: "",
      field: "Col3",
      backendFields:["G3Sales","G3SalesDiff","G3QtySold","G3QtySoldDiff","G3Returns","G3ReturnsDiff","G3Profit","G3ProfitDiff"],
      width: 180,
      minWidth: 180,
      headerClass: "purple",
      cellStyle:{ "border-left": "2px solid #D6D6D6" },
      filter: "agNumberColumnFilter",
      cellRenderer : "salesTrendsCellRendere",
      isSumColumns:true,
      sortable: true,
      cellRendererParams:(params) =>{
        return { col: 3, isOrder:true,defaultColumns:this.salesTrendsGridConfigService.defaultColumns}
      },
      headerComponent: CustomGridHeaderComponent,
      headerComponentParams :{
        isSalesTrend:true,
        callback: this.onHeaderCallback.bind(this)
      },
    },
    {
      headerName: "",
      field: "Col4",
      backendFields:["G4Sales","G4SalesDiff","G4QtySold","G4QtySoldDiff","G4Returns","G4ReturnsDiff","G4Profit","G4ProfitDiff"],
      width: 180,
      minWidth: 180,
      headerClass: "success-light",
      filter: "agNumberColumnFilter",
      cellStyle:{ "border-left": "2px solid #D6D6D6" },
      isSumColumns:true,
      cellRenderer : "salesTrendsCellRendere",
      sortable: true,
      cellRendererParams:(params) =>{
        return { col:4, isOrder:true,defaultColumns:this.salesTrendsGridConfigService.defaultColumns }
      },
      headerComponent: CustomGridHeaderComponent,
      headerComponentParams :{
        isSalesTrend:true,
        callback: this.onHeaderCallback.bind(this)
      },
    },
    {
      headerName:"",
      field: "Col5",
      backendFields:["G5Sales","G5SalesDiff","G5QtySold","G5QtySoldDiff","G5Returns","G5ReturnsDiff","G5Profit","G5ProfitDiff"],
      width: 180,
      minWidth: 180,
      headerClass: "spray",
      cellStyle:{ "border-left": "2px solid #D6D6D6" },
      isSumColumns:true,
      sortable: true,
      filter: "agNumberColumnFilter",
      cellRenderer : "salesTrendsCellRendere",
      cellRendererParams:(params) =>{
        return { col:5, isOrder:true,defaultColumns:this.salesTrendsGridConfigService.defaultColumns}
      },
      headerComponent: CustomGridHeaderComponent,
      headerComponentParams :{
        isSalesTrend:true,
        callback: this.onHeaderCallback.bind(this)
      },
    },
  ]

  onHeaderCallback(e){
    this.sortModel = e;
    this.salesTrendsGridConfigService.gridApi.refreshServerSide({ route: [], purge: true });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}